module.exports = __webpack_public_path__ + "static/img/onlineStudy-videoCover.9c01bebc.jpg";